import React from "react"
import { createRoot } from "react-dom/client"
import { AppView } from "./AppView.tsx"
import 'webgl-lint'

const StrictMode = React.StrictMode

const root = createRoot(document.getElementById("root")!)
root.render(
  <StrictMode>
    <AppView />
  </StrictMode>
)
